import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andy Giesen
 * id 409261FA-D055-4E16-88A0-94C31667F218
 * name checkbox-intermediate-variant
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-intermediate-variant.svg
 * tags
 * - Form 
 */
export const CheckboxIntermediateVariantIcon = createSvgIcon(<><path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 19H5V5H19V19M7 17V7H17" /></>, 'CheckboxIntermediateVariantIcon');
export default CheckboxIntermediateVariantIcon